export const ALL = "all";  
export const PYTHON = "research";     
export const WEB_DEVELOPMENT = "data science";
export const DATA_SCIENCE = "web development";
export const AWS = "advanced technology";
export const DESIGN = "summer school";
export const MARKETING = "internship";
